export default __webpack_public_path__ + "media/_/node_modules/cryptocurrency-icons/svg/color/appc-b4be54ecb68dd6ab30f0c51212787abd.svg";